import { RenderEvenlySpaced } from 'Util/WidgetsUtils.js'
import { SampleTable } from 'View/Component/SampleTable/SampleTable.js'
import type { OrderState } from '../../../Util/OrderState.js'
import type { ISampleMetaData } from '../../../Model/Sample/ISampleMetaData.js'
import type { IOrder, ISamplePool } from '../../../Model/index.js'
import { TooltipTrigger } from '../../../Provider/TooltipManager.js'

export type MetadataTabWidgetProps = {
  editable: boolean
  metadataEditable: boolean
  metadata: ISampleMetaData[]
  order: IOrder
  orderState: OrderState
  allPools: ISamplePool[]
}

export const MetadataTabWidget = (props: MetadataTabWidgetProps) => {
  // Shadowed metadata belongs to negative controls (kept so NC->sample conversion is reversible).
  // It is inactive, so it must not appear in the metadata tab nor inflate the counts below.
  const activeMetadata = props.metadata.filter((x) => !x.isShadowed)

  const mockPool: ISamplePool = {
    id: 'metadata',
    orderId: props.order.id,
    samples: activeMetadata.map((x, index) => {
      return {
        itemType: 'SAMPLE',
        id: `dummy-${index}`,
        forwardFileId: '',
        reverseFileId: '',
        sampleMetadata: x,
        customerSampleName: x.customerSampleName,
        isMerged: false,
        isTrimmed: false,
        version: 'fake'
      }
    }),
    negativeControls: []
  }

  return (
    <div>
      <div className="divide-y">
        {[
          ['Metadata total', activeMetadata.length],
          [
            <TooltipTrigger
              key="metadata-merged-entry"
              tooltip={
                'Metadata, which has already been attached to sample instances. Metadata initially provided by customers is merged to samples when the lab provides its sample sheet.'
              }
            >
              Merged to samples
            </TooltipTrigger>,
            activeMetadata.filter((x) => x.sampleId).length
          ],
          ['Unmerged', activeMetadata.filter((x) => !x.sampleId).length]
        ].map((d) => (
          <RenderEvenlySpaced text={d[0]} value={d[1]} key={`${d[0]}${d[1]}`} />
        ))}
      </div>
      <div className="border-t-2 mt-2 pt-2" />
      <>
        <div className="mt-4 overflow-x-auto">
          <SampleTable
            order={props.order}
            allPools={props.allPools}
            editable={props.editable}
            metadataEditable={props.metadataEditable}
            dataset={mockPool}
            isDone={props.orderState === 'DONE'}
            isMetadataTab
          />
        </div>
      </>
    </div>
  )
}
